import { useMutation } from '@tanstack/react-query'
import { analyticsApi } from 'src/services/analyticsApi'

export interface CampaignCompareExcelExportParams {
  campaignIds: string[]
  fromDate?: string
  metrics?: ('mentions' | 'sources' | 'sentiments')[]
  toDate?: string
}

const exportCampaignComparisonExcel = async (
  params: CampaignCompareExcelExportParams
): Promise<Blob> => {
  const {
    campaignIds,
    metrics = ['mentions', 'sources', 'sentiments'],
    fromDate,
    toDate,
  } = params

  // Build query string
  const queryParams = new URLSearchParams()

  // Add campaign IDs as comma-separated string
  // If empty array, don't add campaignIds param (backend will use all campaigns)
  if (campaignIds.length > 0) {
    queryParams.append('campaignIds', campaignIds.join(','))
  }

  // Add metrics as comma-separated string
  queryParams.append('metrics', metrics.join(','))

  if (fromDate) {
    queryParams.append('fromDate', fromDate)
  }
  if (toDate) {
    queryParams.append('toDate', toDate)
  }

  const queryString = queryParams.toString()
  const url = `/v1_private/campaign/compare/excel?${queryString}`

  // Make GET request expecting blob response
  const response = await analyticsApi().get(url, {
    responseType: 'blob',
  })

  return response.data
}

export const useExportCampaignComparisonExcelQuery = () => {
  return useMutation({
    mutationFn: exportCampaignComparisonExcel,
  })
}
